import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/core/main/home/home.component';
import { ConditionComponent } from './components/core/conditions/condition.component';
import { PrivacyComponent } from './components/core/privacy/privacy.component';
import { ProfileGuard } from './guards/profile.guard';
import { OlxComponent } from './components/core/olx/olx.component';
import { AutoRiaComponent } from './components/core/auto-ria/auto-ria.component';
import { AgroRiaComponent } from './components/core/agro-ria/agro-ria.component';
import { DomRiaComponent } from './components/core/dom-ria/dom-ria.component';
import { InstagramComponent } from './components/core/instagram/instagram.component';
import { ViberComponent } from './components/core/viber/viber.component';
import { TelegramComponent } from './components/core/telegram/telegram.component';
import { PromComponent } from './components/core/prom/prom.component';
import { WhatsAppComponent } from './components/core/whats-app/whats-app.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'olx',
    component: OlxComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'auto-ria',
    component: AutoRiaComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'telegram',
    component: TelegramComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'dom-ria',
    component: DomRiaComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'instagram',
    component: InstagramComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'viber',
    component: ViberComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'agro-ria',
    component: AgroRiaComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'prom',
    component: PromComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'whatsapp',
    component: WhatsAppComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'terms-of-use',
    component: ConditionComponent,
    canActivate: [ProfileGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyComponent,
    canActivate: [ProfileGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [ProfileGuard],
})
export class AppRoutingModule {
}
